

const Title = ({children ,className='text-lg text-gray-800 font-bold'}) => {
  return (
    <h2 className={className}>{children}</h2>
  );
};

export default Title;